import { useState } from "react";

const CustomTooltip = ({
  children,
  text,
  placement = "top",
  bgColor = "#f0e9e9ff",
  textColor = "#303030ff",
}) => {
  const [show, setShow] = useState(false);

  const tooltipPosition = {
    position: "absolute",
    zIndex: 9999,
    whiteSpace: "nowrap",
    color: textColor,
    padding: "6px 10px",
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: 500,
    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
  };

  const arrowBase = {
    position: "absolute",
    width: 0,
    height: 0,
    borderStyle: "solid",
  };

  const placements = {
    top: {
      tooltip: {
        bottom: "calc(100% + 10px)",
        left: "50%",
        transform: "translateX(-50%)",
      },
      arrow: {
        ...arrowBase,
        top: "100%",
        left: "50%",
        transform: "translateX(-50%)",
        borderWidth: "6px 6px 0 6px",
        borderColor: `${bgColor} transparent transparent transparent`,
      },
    },

    bottom: {
      tooltip: {
        top: "calc(100% + 10px)",
        left: "50%",
        transform: "translateX(-50%)",
      },
      arrow: {
        ...arrowBase,
        bottom: "100%",
        left: "50%",
        transform: "translateX(-50%)",
        borderWidth: "0 6px 6px 6px",
        borderColor: `transparent transparent ${bgColor} transparent`,
      },
    },

    left: {
      tooltip: {
        right: "calc(100% + 10px)",
        top: "50%",
        transform: "translateY(-50%)",
      },
      arrow: {
        ...arrowBase,
        left: "100%",
        top: "50%",
        transform: "translateY(-50%)",
        borderWidth: "6px 0 6px 6px",
        borderColor: `transparent transparent transparent ${bgColor}`,
      },
    },

    right: {
      tooltip: {
        left: "calc(100% + 10px)",
        top: "50%",
        transform: "translateY(-50%)",
      },
      arrow: {
        ...arrowBase,
        right: "100%",
        top: "50%",
        transform: "translateY(-50%)",
        borderWidth: "6px 6px 6px 0",
        borderColor: `transparent ${bgColor} transparent transparent`,
      },
    },
  };

  return (
    <div
      style={{
        position: "relative",
        display: "inline-flex",
      }}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {children}

      {show && (
        <div
          style={{
            ...tooltipPosition,
            ...placements[placement].tooltip,
          }}
          className="fw-normal border border-1"
        >
          {text}

          <div
            style={{
              ...placements[placement].arrow,
            }}
          />
        </div>
      )}
    </div>
  );
};

export default CustomTooltip;